function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash.uniqueid';
import { Button, Col, CustomInput, Icon, Label } from '@appfolio/react-gears';

var SortHeader = function SortHeader(_ref) {
  var ascending = _ref.ascending,
      sortByLabel = _ref.sortByLabel,
      sortOptions = _ref.sortOptions,
      sortProperty = _ref.sortProperty,
      onChangeAscending = _ref.onChangeAscending,
      onChangeProperty = _ref.onChangeProperty;

  var _useState = useState(function () {
    return uniqueId('sort-');
  }),
      _useState2 = _slicedToArray(_useState, 1),
      sortId = _useState2[0];

  return /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    sm: "auto",
    className: "ml-sm-auto mr-n1 pt-2 pt-sm-0 d-flex align-items-center js-sort-header"
  }, /*#__PURE__*/React.createElement(Label, {
    className: "m-0 pr-2 text-nowrap col-form-label",
    for: sortId
  }, sortByLabel), /*#__PURE__*/React.createElement(CustomInput, {
    id: sortId,
    type: "select",
    onChange: function onChange(e) {
      var value = e.target.value;
      onChangeProperty(value && value.includes(',') ? value.split(',') : value);
    },
    value: Array.isArray(sortProperty) ? sortProperty.join(',') : sortProperty
  }, sortProperty === undefined && /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "--"), sortOptions.map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value;
    return /*#__PURE__*/React.createElement("option", {
      key: value,
      value: Array.isArray(value) ? value.join(',') : value
    }, label);
  })), sortProperty && /*#__PURE__*/React.createElement(Button, {
    className: "ml-1 pl-2 pr-0",
    color: "link",
    disabled: !sortProperty,
    id: "sort-button",
    onClick: function onClick() {
      return onChangeAscending(!ascending);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: ascending ? 'arrow-down' : 'arrow-up',
    size: "lg"
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Change Sort Direction")));
};

SortHeader.displayName = "SortHeader";
SortHeader.propTypes = {
  ascending: PropTypes.bool.isRequired,
  onChangeAscending: PropTypes.func.isRequired,
  onChangeProperty: PropTypes.func.isRequired,
  sortByLabel: PropTypes.string.isRequired,
  sortOptions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  sortProperty: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired
};
export default SortHeader;